import Cookies from "universal-cookie";
import { BaseApi } from "./BaseUrl";
import axios from "axios";

export async function UserMissions(): Promise<Array<{}>> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};

        const response = await axios.get(BaseApi+'HR/UserMissions',requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
    }
}